import type { EstadoAsistencia, EstadoReunion } from "./api";
import { Badge, type BadgeTone } from "../../components/ui";

const REUNION_TONES: Record<EstadoReunion, BadgeTone> = {
  Programada: "brand",
  Realizada: "amber",
  Cerrada: "emerald",
  Cancelada: "slate",
};

export function EstadoReunionBadge({
  estado,
}: {
  estado: EstadoReunion;
}): JSX.Element {
  return <Badge tone={REUNION_TONES[estado]}>{estado}</Badge>;
}

const ASIST_TONES: Record<EstadoAsistencia, BadgeTone> = {
  Presente: "emerald",
  Ausente: "rose",
  Justificado: "amber",
};

export function EstadoAsistenciaBadge({
  estado,
}: {
  estado: EstadoAsistencia;
}): JSX.Element {
  return <Badge tone={ASIST_TONES[estado]}>{estado}</Badge>;
}
